var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27752 18.0924C5.06114 17.6913 5.06114 17.2048 5.27752 16.8038C7.88506 11.9815 12.7019 7.80139 17.5187 7.80139C22.3355 7.80139 27.1523 11.9815 29.7598 16.8051C29.9762 17.2062 29.9762 17.6927 29.7598 18.0938C27.1523 22.9161 22.3355 27.0961 17.5187 27.0961C12.7019 27.0961 7.88506 22.9161 5.27752 18.0924Z",
    stroke: "#828282",
    strokeWidth: 2.06729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.442 14.5252C22.0566 16.1399 22.0566 18.7577 20.442 20.3724C18.8273 21.987 16.2094 21.987 14.5948 20.3724C12.9801 18.7577 12.9801 16.1399 14.5948 14.5252C16.2094 12.9105 18.8273 12.9105 20.442 14.5252",
    stroke: "#828282",
    strokeWidth: 1.96889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassEye);
export default __webpack_public_path__ + "static/media/passEye.108157d0560c3d4867923e44ab7ca251.svg";
export { ForwardRef as ReactComponent };